import { useMemo } from "react";
import { useSelector } from "react-redux";
import { permissions } from "../../lib/constants";

export default function useUploadDocumentsAuth({
    invoiceData
} = {}){

    const { data } = useSelector((state) => (state.user ? state.user : state));
    const permission = data?.permissions;
    const userId = data?.id;

    const canView = useMemo(() => {
        return permission?.includes(permissions?.UPLOAD_DOCUMENT_READ)
    }, [permission])

    const canInsert = useMemo(() => {
        return permission?.includes(permissions?.UPLOAD_DOCUMENT_CREATE) && !invoiceData?.is_already_max
    }, [permission, invoiceData])

    const canDelete = useMemo(() => {
        return permission?.includes(permissions?.UPLOAD_DOCUMENT_DELETE)
    }, [permission])

    return {
        userId,
        canView,
        canInsert,
        canDelete,
    }  
}